import script from "./StarRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=790e942c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790e942c"]])

export default __exports__